import { LayoutComponent } from '@common/layout/layout.component';
import { AccountantGuard } from '@core/guards/accountant.guard';
import { AdminGuard } from '@core/guards/admin.guard';
import { ReportGuard } from '@core/guards/report.guard';
import { SaleGuard } from '@core/guards/sale.guard';
import { WarehouseGuard } from '@core/guards/warehouse.guard';
import { AuthorizationGuard } from '@guards/authorization.guard';
import { ConfigsComponent } from './configs/configs.component';
import { PartnersComponent } from './configs/partners/partners.component';
import { ProductsComponent } from './configs/products/products.component';
import { ServicesComponent } from './configs/services/services.component';
import { SettingsComponent } from './configs/settings/settings.component';
import { UsersComponent } from './configs/users/users.component';
import { DiscountsComponent } from './discounts/discounts.component';
import { GoodsComponent } from './goods/goods.component';
import { HomeComponent } from './home/home.component';
import { ExportsComponent as ExportInvoices } from './invoices/exports/exports.component';
import { ImportsComponent as ImportInvoices } from './invoices/imports/imports.component';
import { LossesComponent } from './invoices/losses/losses.component';
import { ReturnsComponent } from './invoices/returns/returns.component';
import { VerificationComponent } from './invoices/verification/verification.component';
import { LoginComponent } from './login/login.component';
import { ExportsComponent as ExportOrders } from './orders/exports/exports.component';
import { ImportsComponent as ImportOrders } from './orders/imports/imports.component';
import { PricesComponent } from './orders/prices/prices.component';
import { DebtsComponent } from './debts/debts.component';
import { ServicesComponent as ServicePaymentsComponent } from './payments/services/services.component';
import { GeneralReportComponent } from './reports/general-report/general-report.component';
import { InventoryReportByCustomersComponent } from './reports/inventory-report-by-customers/inventory-report-by-customers.component';
import { InventoryReportByImportsComponent } from './reports/inventory-report-by-imports/inventory-report-by-imports.component';
import { InventoryReportByProductsComponent } from './reports/inventory-report-by-products/inventory-report-by-products.component';
import { PaymentReportComponent } from './reports/payment-report/payment-report.component';
import { PriceReportByProductsComponent } from './reports/price-report-by-products/price-report-by-products.component';
import { ReportsComponent } from './reports/reports.component';

export const routes = [

  {
    path: 'login',
    component: LoginComponent,    
  },

  {    
    path: '',
    component: LayoutComponent,
    canActivate: [AuthorizationGuard],
    

    children: [

      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },

      { path: 'configs', component: ConfigsComponent, canActive: [AdminGuard] },
      { path: 'configs/users', component: UsersComponent, canActivate: [AdminGuard] },
      { path: 'configs/partners', component: PartnersComponent, canActivate: [AdminGuard] },
      { path: 'configs/products', component: ProductsComponent, canActivate: [AdminGuard] },
      { path: 'configs/services', component: ServicesComponent, canActivate: [AdminGuard] },
      { path: 'configs/settings', component: SettingsComponent, canActivate: [AdminGuard] },

      { path: 'orders/exports', component: ExportOrders, canActive: [SaleGuard] },
      { path: 'orders/prices', component: PricesComponent, canActive: [AdminGuard] },
      { path: 'orders/imports', component: ImportOrders, canActive: [SaleGuard] },

      { path: 'invoices/exports', component: ExportInvoices, canActive: [WarehouseGuard] },
      { path: 'invoices/imports', component: ImportInvoices, canActive: [AccountantGuard] },
      { path: 'invoices/verification', component: VerificationComponent, canActive: [WarehouseGuard] },
      { path: 'invoices/losses', component: LossesComponent, canActive: [WarehouseGuard] },
      { path: 'invoices/returns', component: ReturnsComponent, canActive: [WarehouseGuard] },

      { path: 'discounts', component: DiscountsComponent, canActive: [AccountantGuard] },

      { path: 'goods', component: GoodsComponent, canActive: [WarehouseGuard] },

      { path: 'debts', component: DebtsComponent, canActive: [AccountantGuard] },
      { path: 'payments/services', component: ServicePaymentsComponent, canActive: [AccountantGuard] },

      { path: 'reports', component: ReportsComponent, canActive: [ReportGuard] },
      { path: 'reports/inventory-report-by-products', component: InventoryReportByProductsComponent, canActive: [ReportGuard] },
      { path: 'reports/inventory-report-by-customers', component: InventoryReportByCustomersComponent, canActive: [ReportGuard] },
      { path: 'reports/inventory-report-by-imports', component: InventoryReportByImportsComponent, canActive: [ReportGuard] },
      { path: 'reports/payment-report', component: PaymentReportComponent, canActive: [ReportGuard] },
      { path: 'reports/price-report-by-products', component: PriceReportByProductsComponent, canActive: [ReportGuard] },
      { path: 'reports/general-report', component: GeneralReportComponent, canActive: [ReportGuard] }
    ]    
  },

  // Not found
  { path: '**', redirectTo: 'login' }
];
